module.exports = __webpack_public_path__ + "static/media/cornerstone.008293fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/cornerstone.svg
// module id = 267
// module chunks = 0